import { render, staticRenderFns } from "./TextInfo.vue?vue&type=template&id=1f90eb40&"
import script from "./TextInfo.vue?vue&type=script&lang=js&"
export * from "./TextInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports